import $ from 'jquery';

export const init = () => {

	// detect IOS, Android
	function goToUri(uri, href) {
		var start, end, elapsed;

		setTimeout(function () { window.location = href; }, 50);
		window.location = uri;
	}

	function goToUriBad(uri, href) {
		if(!window.open(uri) && href !== undefined) {
			window.location = href;
		}
	}

	function goToFB(uri, fbUri) {
		start = new Date().getTime();

		// attempt to redirect to the uri:scheme
		// the lovely thing about javascript is that it's single threadded.
		// if this WORKS, it'll stutter for a split second, causing the timer to be off
		document.location = uri;

		// end timer
		end = new Date().getTime();

		elapsed = (end - start);

		if (elapsed <  1 ) {
			try {
				FB.ui({
					method: 'feed',
					link: fbUri,
					caption: 'Přečtěte si',
				}, function(response){});
			} catch(e) {
				console.log('fb share error');
			}

		}
	}

	$(document).ready(function() {
		var IS_IPAD = navigator.userAgent.match(/iPad/i) != null,
			IS_IPHONE = !IS_IPAD && ((navigator.userAgent.match(/iPhone/i) != null) || (navigator.userAgent.match(/iPod/i) != null)),
			IS_IOS = IS_IPAD || IS_IPHONE,
			IS_ANDROID = !IS_IOS && navigator.userAgent.match(/android/i) != null,
			IS_MOBILE = IS_IOS || IS_ANDROID;

		if (IS_IOS) {

			$('a.intent').on('click', function (event) {
				goToUri($(this).data('uri-scheme'), $(this).data('store-ios'));
				event.preventDefault();
				return false;
			});

		} else if (IS_ANDROID ) {

			$('a.intent').on('click', function (event) {
				goToUri($(this).data('uri-scheme'), $(this).data('store-android'));
				event.preventDefault();
				return false;
			});

		} else {

			$('a.intent').on('click', function (event) {
				goToUri($(this).data('uri-scheme'));
				event.preventDefault();
				return false;
			});

		}

		$('a.fb').on('click',function(event ){
			goToFB($(this).data('uri-scheme'), $shareStripUrl);
			event.preventDefault();
			return false;
		});

		$('a.twitt').on('click', function(event) {
			goToUri($(this).data('uri-scheme'), $(this).data('fallback-uri'));
			event.preventDefault();
			return false;
		});

	});

};



// WEBPACK FOOTER //
// ./src/js/components/share.js